<template>
  <div>
    <div class="toolbar">
      <el-button type="primary" icon="el-icon-plus" @click="openCreate">生成邀请码</el-button>
    </div>
    <el-table :data="list" border stripe v-loading="loading">
      <el-table-column prop="code" label="邀请码" width="160">
        <template slot-scope="{ row }">
          <b>{{ row.code }}</b>
          <el-button type="text" @click="copy(row.code)">复制</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="bindType" label="类型" width="100">
        <template slot-scope="{ row }">{{ row.bindType === 'PROJECT' ? '项目' : '公司' }}</template>
      </el-table-column>
      <el-table-column prop="projectName" label="项目名称" min-width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.projectName || '-' }}</template>
      </el-table-column>
      <el-table-column prop="projectAddress" label="项目地址" min-width="180" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.projectAddress || '-' }}</template>
      </el-table-column>
      <el-table-column label="使用" width="120">
        <template slot-scope="{ row }">{{ row.usedCount || 0 }} / {{ row.maxUses > 0 ? row.maxUses : '不限' }}</template>
      </el-table-column>
      <el-table-column label="过期时间" width="170">
        <template slot-scope="{ row }">{{ row.expireAt || '永久' }}</template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.status === 'ON' ? 'success' : 'info'">{{ row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" min-width="160" />
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="showQr(row)">小程序码</el-button>
          <el-button type="text" class="op-danger" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="生成邀请码" :visible.sync="visible" width="480px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="绑定类型" required>
          <el-radio-group v-model="form.bindType">
            <el-radio label="TENANT">公司</el-radio>
            <el-radio label="PROJECT">项目</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="bind-type-tip">
          <p>公司：绑定后查看公司的内容、活动和案例。</p>
          <p>项目：绑定后除了查看公司相关信息，还可以查看绑定的项目信息。</p>
        </div>
        <el-form-item v-if="form.bindType === 'PROJECT'" label="项目" required>
          <el-select v-model="form.projectId" filterable style="width:100%" placeholder="选择项目">
            <el-option
              v-for="p in projects"
              :key="p.id"
              :label="(p.name || p.customerName) + ' #' + p.id"
              :value="p.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="最大次数">
          <el-input-number v-model="form.maxUses" :min="0" />
          <span class="hint">0 表示不限制</span>
        </el-form-item>
        <el-form-item label="有效天数">
          <el-input-number v-model="form.expireDays" :min="0" />
          <span class="hint">0 表示永久</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">生成</el-button>
      </div>
    </el-dialog>

    <el-dialog title="邀请小程序码" :visible.sync="qrVisible" width="420px" center>
      <div class="qr-box" v-loading="qrLoading">
        <p class="qr-code">邀请码：<b>{{ qrCode }}</b></p>
        <img v-if="qrDataUrl" :src="qrDataUrl" class="qr-img" alt="小程序码" />
        <p class="hint">客户用微信扫一扫即可打开小程序并绑定（当前为开发版码）</p>
      </div>
      <div slot="footer">
        <el-button @click="downloadQr" :disabled="!qrDataUrl">下载图片</el-button>
        <el-button type="primary" @click="qrVisible=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listInvites, createInvite, inviteQrcode, deleteInvite } from '../../api/cms'
import { listProjects } from '../../api/project'

export default {
  name: 'CmsInvite',
  data() {
    return {
      list: [],
      projects: [],
      loading: false,
      saving: false,
      visible: false,
      form: {
        bindType: 'TENANT',
        projectId: null,
        maxUses: 0,
        expireDays: 0
      },
      qrVisible: false,
      qrLoading: false,
      qrCode: '',
      qrDataUrl: ''
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await listInvites()
        this.list = res.data || []
      } finally {
        this.loading = false
      }
    },
    async openCreate() {
      this.form = { bindType: 'TENANT', projectId: null, maxUses: 0, expireDays: 0 }
      try {
        const res = await listProjects({})
        this.projects = res.data || []
      } catch (e) {
        this.projects = []
      }
      this.visible = true
    },
    async save() {
      if (this.form.bindType === 'PROJECT' && !this.form.projectId) {
        return this.$message.warning('请选择项目')
      }
      this.saving = true
      try {
        const res = await createInvite({
          bindType: this.form.bindType,
          projectId: this.form.bindType === 'PROJECT' ? this.form.projectId : null,
          maxUses: this.form.maxUses || 0,
          expireDays: this.form.expireDays > 0 ? this.form.expireDays : null
        })
        const row = res.data || {}
        this.$message.success(row.code ? ('已生成：' + row.code) : '已生成')
        this.visible = false
        await this.load()
        if (row.id) {
          this.showQr(row)
        }
      } finally {
        this.saving = false
      }
    },
    async showQr(row) {
      this.qrVisible = true
      this.qrLoading = true
      this.qrCode = row.code || ''
      this.qrDataUrl = ''
      try {
        const res = await inviteQrcode(row.id)
        const data = res.data || {}
        this.qrCode = data.code || row.code
        this.qrDataUrl = data.dataUrl || ''
      } catch (e) {
        this.qrVisible = false
      } finally {
        this.qrLoading = false
      }
    },
    downloadQr() {
      if (!this.qrDataUrl) return
      const a = document.createElement('a')
      a.href = this.qrDataUrl
      a.download = 'invite-' + (this.qrCode || 'qrcode') + '.png'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    onDelete(row) {
      if (!row || !row.id) return
      this.$confirm(`确认删除邀请码「${row.code}」？删除后不可再使用。`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteInvite(row.id)
          this.$message.success('已删除')
          this.load()
        })
        .catch(() => {})
    },
    copy(text) {
      if (!text) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => this.$message.success('已复制'))
        return
      }
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('已复制')
    }
  }
}
</script>

<style scoped>
.hint { margin-left: 8px; color: #94a3b8; font-size: 12px; }
/* 与 label-width:100px、右对齐四字标题（如「最大次数」）左边缘对齐 */
.bind-type-tip {
  margin: -8px 0 18px;
  padding-left: calc(100px - 12px - 4em);
  font-size: 14px;
  line-height: 1.7;
  color: #94a3b8;
  text-align: left;
}
.bind-type-tip p {
  margin: 0;
  font-size: 12px;
}
.qr-box { text-align: center; min-height: 280px; }
.qr-code { margin-bottom: 12px; color: #334155; }
.qr-img { width: 260px; height: 260px; background: #f8fafc; }
.qr-box .hint { margin: 12px 16px 0; display: block; margin-left: 0; }
.op-danger { color: #ef4444; }
</style>
